import { DesignVersionProvider } from 'mage-deps/@klarna/bubble-ui'
import { ConnectedRouter } from 'mage-deps/connected-react-router'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'

import EnvironmentIdentifier from '../EnvironmentIdentifier'

const Public = ({ App, history, designVersion, location, footerConfig, t, clientId, Framework }) => {
  useEffect(() => {
    const title = t(`core.apps.${clientId}.title`)
    if (title) {
      document.title = `${title} | Klarna Merchant Portal`
    }
  }, [t, clientId])

  return (
    <ConnectedRouter history={history}>
      <EnvironmentIdentifier />
      <Framework footerConfig={{ text: footerConfig.text }}>
        <DesignVersionProvider value={designVersion}>
          <App location={location} />
        </DesignVersionProvider>
      </Framework>
    </ConnectedRouter>
  )
}

Public.propTypes = {
  App: PropTypes.any,
  Framework: PropTypes.any.isRequired,
  history: PropTypes.object,
  location: PropTypes.object,
  designVersion: PropTypes.string,
  footerConfig: PropTypes.object,
  t: PropTypes.func.isRequired,
  clientId: PropTypes.string
}

export default Public
